module.exports = __webpack_public_path__ + "img/return.1257fbdd.svg";